import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';
import { convertUriToTagText, formatDate, getDefaultFilename } from '@/utilities';

const BlogCard = props => {
    const {uri, blogMetaFields} = props || {};
    const {title, publishDate, heroImage, thumbnailImage} = blogMetaFields || {};

    const renderImage = () => {
        const imageSource = thumbnailImage?.node || heroImage?.node;
        const {mediaDetails, mediaItemUrl, altText} = imageSource || {};
        let imageUri = mediaItemUrl;
        
        if(uri) {
            if(!mediaItemUrl) {
                imageUri = getDefaultFilename(uri);
            }
        }

        return (
            <Link className={styles.blogCard__imageLink} href={uri || '#'}>
                <Image 
                    src={imageUri || `/default_webinars.jpg`} 
                    width={mediaDetails?.width || 260}  
                    height={mediaDetails?.height || 200}   
                    alt={altText || "Blog Post"}   
                    className={styles.blogCard__image} 
                />
            </Link>            
        );
    }

    return(
        <div className={styles.blogCard}>
            <div className={styles.blogCard__inner}>
                {renderImage()}
                <div className={styles.blogCard__content}>
                    <div className={styles.blogCard__meta}>
                        <Link alt={title || "Daxko"}  className={`${styles.blogCard__meta} tag`} href="#">
                            {convertUriToTagText(uri)}
                        </Link>
                        <span className={`${styles.blogCard__date}`}>
                            {publishDate ? formatDate(publishDate): null}
                        </span>
                    </div>
                    <div className={`${styles.blogCard__copy}`}>
                        <p>
                            {title || `Lorem ipsum dolor sit amet consectetur.`}
                        </p>
                    </div>
                    <Link href={uri || '#'} className={`${styles.blogCard__cta} cta_arrow`}>
                        Read More
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#D41050"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default BlogCard;
